import React, { useEffect, useState } from "react";
import SubmissionsTable from "./SubmissionsTable";
import Http from "../Reports/http";
import useDeepCompareEffect from "../Hooks/useDeepCompareEffect";
import Paginate from "../utils/Paginate";
import Notice from "../Notice";

const SubmissionsIndex = (props) => {
  const [notice, setNotice] = React.useState({
    kind: "error",
    open: false,
    message: "",
  });
  const [submissions, setSubmissions] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [isSubmissionsLoading, setIsSubmissionsLoading] = useState(false);

  useEffect(() => {
    fetchSubmissions();
  }, []);

  useDeepCompareEffect(() => {
    fetchSubmissions();
  }, [currentPageIndex]);

  const fetchSubmissions = async () => {
    setIsSubmissionsLoading(true);
    const pagedQuery = { page: currentPageIndex + 1 };

    await Http.fetchQuery(props.query_path, pagedQuery)
      .then((res) => {
        setSubmissions(res.submissions);
        setTotalPages(res.total_pages);
      })
      .catch((error) => {
        setNotice({ kind: "error", open: true, message: "Error fetching data" });
      })
      .finally(() => setIsSubmissionsLoading(false));
  };

  return (
    <>
      <SubmissionsTable
        submissionType={props.submissionType}
        submissions={submissions}
        api_submissions_row_data_path={props.api_submissions_row_data_path}
        api_submissions_summary_path={props.api_submissions_summary_path}
        isLoading={isSubmissionsLoading}
        currentPageIndex={currentPageIndex}
        setNotice={setNotice}
      />
      {totalPages > 1 && (
        <Paginate
          totalPages={totalPages}
          setCurrentPage={setCurrentPageIndex}
          containerClassName="pagination pagination--right"
        />
      )}
      <Notice details={notice} />
    </>
  );
};

export default SubmissionsIndex;
